const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function fetchDbArticles() {
  try {
    const r = await fetch(`${API}/articles`);
    if (!r.ok) return [];
    const data = await r.json();
    return Array.isArray(data.articles) ? data.articles : [];
  } catch {
    return [];
  }
}
